import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';
import type { IRenewalSmsConfigTabProps } from '@/@types/insurance';

export function RenewalSmsConfigTab({
  smsConfig,
  onSmsConfigChange,
}: IRenewalSmsConfigTabProps) {
  const websmsApiKey = smsConfig?.websmsApiKey ?? '';
  const senderName = smsConfig?.senderName ?? '';
  const [showApiKey, setShowApiKey] = useState(false);

  return (
    <div className="space-y-6 py-4">
      <p className="text-sm text-muted-foreground">
        SMS notifications are sent via WebSMS. Enter your API credentials below.
      </p>

      <div className="space-y-2">
        <Label htmlFor="websms-api-key">WebSMS API key</Label>
        <div className="relative max-w-[360px]">
          <Input
            id="websms-api-key"
            type={showApiKey ? 'text' : 'password'}
            placeholder="Enter your WebSMS API key"
            value={websmsApiKey}
            onChange={e =>
              onSmsConfigChange({ websmsApiKey: e.target.value, senderName })
            }
            className="pr-10"
          />
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="absolute right-0 top-0 h-full w-9 text-muted-foreground hover:text-foreground"
            onClick={() => setShowApiKey(prev => !prev)}
            aria-label={showApiKey ? 'Hide API key' : 'Show API key'}
          >
            {showApiKey ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
          </Button>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="sender-name">Sender name</Label>
        <Input
          id="sender-name"
          type="text"
          placeholder="e.g. MyInsure"
          value={senderName}
          maxLength={11}
          onChange={e =>
            onSmsConfigChange({ websmsApiKey, senderName: e.target.value })
          }
          className="max-w-[360px]"
        />
        <p className="text-xs text-muted-foreground">
          3–11 alphanumeric characters. This is shown to the recipient as the sender.
        </p>
      </div>
    </div>
  );
}
